// extracted by mini-css-extract-plugin
export var link = "_q7-0";